import $ from 'jquery'

export let showModal = () => {
  $('#service-check-modal').modal('show')
}
